/* eslint-disable no-console */
import chalk from 'chalk';
import dayjs from 'dayjs';
import { RequestOptions, RequestResponse, RequestError } from '../types';

chalk.level = 1;

export function requestLogger(options: RequestOptions) {
  console.log(`--> [${dayjs().format('HH:mm:ss.SSS')}] ${chalk.yellow(options.method.toUpperCase())} ${options.url}`);
  return options;
}
export function errorLogger(error: RequestError) {
  console.log(error);
  return Promise.reject(error);
}

export function responseLogger(response: RequestResponse) {
  const options = response.config;
  console.log(`<-- [${dayjs().format('HH:mm:ss.SSS')}] ${chalk.yellow(options.method.toUpperCase())} ${response.status} ${options.url}`);
  return response;
}
